import React, { FC } from "react";
import { COLOR_BLACK } from "../colors";
import { IconType } from "./types";

export const ArrowCurvedUpIcon: FC<IconType> = ({
  color = COLOR_BLACK,
}) => (
  <svg
    width="12"
    height="7"
    viewBox="0 0 12 7"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11 1L7.06568 4.93432C6.86768 5.13232 6.76867 5.23133 6.65451 5.26842C6.55409 5.30105 6.44591 5.30105 6.34549 5.26842C6.23133 5.23133 6.13232 5.13232 5.93431 4.93431L4.56568 3.56568C4.36768 3.36768 4.26867 3.26867 4.15451 3.23158C4.05409 3.19895 3.94591 3.19895 3.84549 3.23158C3.73133 3.26867 3.63232 3.36768 3.43431 3.56569L1 6M11 1H7.5M11 1V4.5"
      stroke={color}
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
